// extracted by mini-css-extract-plugin
export var bar = "progressBar-module--bar--Kwusu";
export var background = "progressBar-module--background--RmNWV";
export var progress = "progressBar-module--progress--j19hU";
export var slideUp = "progressBar-module--slideUp--2GNyg";
export var slideUpLarge = "progressBar-module--slideUpLarge--0iVy9";